var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMissingDocumentsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "1.87rem",
    viewBox: "0 0 45 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "file-circle-exclamation-solid",
    d: "M0,5A5,5,0,0,1,5,0H17.5V10A2.5,2.5,0,0,0,20,12.5H30v3.016a13.76,13.76,0,0,0-4.242,24.43A4.876,4.876,0,0,1,25,40H5a5,5,0,0,1-5-5Zm30,5H20V0Zm3.75,7.5A11.25,11.25,0,1,1,22.5,28.75,11.25,11.25,0,0,1,33.75,17.5Zm0,18.75a1.875,1.875,0,1,0-1.875-1.875A1.875,1.875,0,0,0,33.75,36.25Zm0-15A1.254,1.254,0,0,0,32.5,22.5v6.25a1.25,1.25,0,1,0,2.5,0V22.5A1.254,1.254,0,0,0,33.75,21.25Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissingDocumentsIcon);
export default __webpack_public_path__ + "static/media/missing-documents-icon.671834de5f6fef902f12b7fd9293feb8.svg";
export { ForwardRef as ReactComponent };